import { Link } from "react-router-dom";
import SearchBar from "@/components/base/SearchBar";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import LatestNews from "@/pages/home/components/LatestNews";
import FeaturedPlots from "@/pages/home/components/FeaturedPlots";
import IntroBand from "@/pages/home/components/IntroBand";

export default function Home() {
  return (
    <>
      <HeroCarousel />
      <CategoryEntries />

      <section className="w-full px-4 md:px-8 pt-12 md:pt-16">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            快速查找剧情与角色
          </h2>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            输入关键词，即可在全部剧情章节、角色档案与资讯中快速定位你想了解的内容。
          </p>
          <div className="mt-6">
            <SearchBar size="lg" />
          </div>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-2 text-xs text-foreground-500">
            <span>热门搜索：</span>
            {["天台", "林静书", "结局", "配乐"].map((kw) => (
              <Link
                key={kw}
                to={`/search?q=${encodeURIComponent(kw)}`}
                className="px-2.5 py-1 rounded-full bg-background-100 text-secondary-700 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                {kw}
              </Link>
            ))}
          </div>
        </div>
      </section>

      <LatestNews />
      <FeaturedPlots />
      <IntroBand />
    </>
  );
}